import React, {useContext} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import TableSearch from '../components/TableSearch'
import changes from '../redux/changesDuck'
import mapDuck from '../redux/mapDuck'
import {polygonCenter} from "../utils/getCenter";
import {useFirestoreConnect} from "react-redux-firebase";
import {activeChangeSelector} from "../redux/changesSelectors";



function Table(props){
      const {changeFeatures, activeLayerId, changeType, selectedValue, selected} = useSelector(activeChangeSelector)
      useFirestoreConnect({collection: activeLayerId, doc:changeType,
                          subcollections: [{collection: 'qa' }]})
      const fbData = useSelector(state => state.firestore.data)
    const rowsPerPage= useSelector((state)=> state.table.currentPageLength)

     let qaValues = fbData[activeLayerId] && fbData[activeLayerId].ndvi.qa

      const mapState = useSelector(state=> state.map)
      const dispatch = useDispatch();

    if (!changeFeatures['features']) {
      return null
    }
    if (!qaValues){
        qaValues = {}
    }

    const modChanges = changeFeatures.features.map((o, i)=> constructRow(o, qaValues))


    const changeView = (state) => {
        dispatch(changes.actions.setFocus(state))
        const [[bx, by], [tx, ty]] = mapState.bbox
        const [lat, long] = state.slice(2,4)
        if (((lat <= tx) && (lat >=bx)) &&  ((long <= ty) && (long >=by)) ){return}
      dispatch(mapDuck.actions.setViewport(state))
    }


    return (
      <TableSearch data={modChanges} onClick={changeView} selected={selectedValue} rowsPerPage={rowsPerPage}/>
    )

    function constructRow(feature, statusValues){
        const event_id = feature['properties']['event_id']
        return {

        ...polygonCenter(feature['geometry']),
        event_id, comment:'ok',
        status:  statusValues[event_id.toString()] && qaValues[event_id.toString()].status
}


    }
  }


export default Table



// WEBPACK FOOTER //
// ./src/containers/Table.js